
import CourseCard from "@/components/CourseCard";

interface CourseType {
  id: string;
  title: string;
  description: string;
  imageSrc: string;
  price: number;
  duration: string;
  level: string;
  lessonCount: number;
}

interface RelatedCoursesProps {
  courses: CourseType[];
}

const RelatedCourses = ({ courses }: RelatedCoursesProps) => {
  if (!courses || courses.length === 0) {
    return null;
  }

  return (
    <div className="mt-20">
      <h2 className="text-2xl font-medium mb-8 text-center">Seotud kursused</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {courses.map(course => (
          <CourseCard key={course.id} course={course} />
        ))}
      </div>
    </div>
  );
};

export default RelatedCourses;
